import { createContext } from 'react';

import type { AnalyticsSendEventEntity } from './analytics.entity';

export const AnalyticsContext = createContext<
  ({ event, payload }: AnalyticsSendEventEntity) => void
>(null!);
